import { render, staticRenderFns } from "./PermohonanDetails.vue?vue&type=template&id=373492c4&"
import script from "./PermohonanDetails.vue?vue&type=script&lang=js&"
export * from "./PermohonanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports